export const API_URL =
	process.env.NODE_ENV === 'production'
		? process.env.REACT_APP_PROD_API_URL
		: process.env.REACT_APP_DEV_API_URL || 'http://0.0.0.0:3000/dev'

export const WS_URL =
	process.env.NODE_ENV === 'production'
		? process.env.REACT_APP_PROD_WS_URL
		: process.env.REACT_APP_DEV_WS_URL || 'ws://0.0.0.0:3001/dev'
